module.exports = __webpack_public_path__ + "media/entities/1142-dab737fb.png";